import { gate } from 'hub-http/gates';

// Preferred FE Usage as described here https://product.hubteam.com/docs/gating/next-gen/frontend-usage.html#frontend-usage
export const GATE_COPILOT_SALES_ACCESS = gate('Copilot:SalesCopilot');
export const GATE_AGENT_AI_STUDIO = gate('AIAgent:AIStudio');